import Router from 'next/router';

import { QP_QUOTES_PARAMS } from '@/constants';

const checkout = ({
  destination,
  propertyContent,
  roomType,
  packageOffer,
  flightSegments,
  searchQuery,
  isProcuredOffer,
}) => {
  sessionStorage.setItem(
    QP_QUOTES_PARAMS,
    JSON.stringify({
      destination: destination.title,
      travelType: destination.travelType,
      propertyId: propertyContent.id,
      propertyName: propertyContent.name,
      roomTypeId: roomType.id,
      roomTypeName: roomType.name,
      offerId: packageOffer.hotelOffer.id,
      offerLabel: packageOffer.hotelOffer.label || 'STANDARD OFFER',
      flights: flightSegments,
      isProcuredOffer,
      destinationName: destination.name,
      ...searchQuery,
    }),
  );

  return Router.push('/checkout').then(() => window.scroll(0, 0));
};

export default checkout;
